import React, { Component } from 'react';

import { NumberInput } from '../components/NumberInput.tsx';
import { ErrorBox } from '../components/ErrorBox.tsx';
import { NextButton } from '../components/NextButton.tsx';
import { PreviousButton } from '../components/PreviousButton.tsx';
import { LenderRow } from '../components/LenderRow';

interface IProps {
    gtmEvent(): void;
    prevStep(): void;
    nextStep(): void;
    updateLead(props: any): void;
    rentOrMortgage?: number;
    monthlySavings?: number;
    mortgageamount?:number;
    lvloanrepayment?:number;
    mortgageType?:string;
}

interface IState {
    hasError: boolean;
    errors?: string[];
    rentOrMortgage?: number;
    monthlySavings?: number;
    lvloanrepayment?:number;
}

export class PaymentsAndSavings extends Component<IProps, IState> {

    constructor (props: IProps) {
        super(props);
        this.state = {hasError: false, rentOrMortgage: this.props.rentOrMortgage, monthlySavings: this.props.monthlySavings};
    }

    componentDidMount(): void {
        this.props.gtmEvent();
    }

    nextStep() {
        if (!this.state.monthlySavings) {
            var errors:string[]=[];
            if (!this.state.rentOrMortgage) {
                errors.push("Rent or mortgage is required");
            }
            if (!this.state.monthlySavings) {
                errors.push("Monthly savings is required");
            }
            this.setState({errors: errors, hasError: true});
            return;
        }
        if (!this.state.rentOrMortgage) {
            this.props.updateLead({monthlyRepayments: 0});
        }
        this.props.nextStep();
    }

    render() {

        return (
            <header className="App-header">
                <h1 className='l'>What are your monthly<br /><span className='doddltext'>payments & savings?</span></h1>
                <div className='wrapper'>
                    <div className='row'>
                    {this.props.mortgageType!=='switcher' && (<>
                        <div className='column2 justify-e'>
                            <NumberInput
                                id='rentormortgage'
                                key='rentormortgage'
                                label={<>Monthly rent or mortgage</>}
                                value={this.props.rentOrMortgage}
                                classes={this.state.hasError && !this.state.rentOrMortgage ? "e" : ""}
                                onChange={(e) => { this.setState({rentOrMortgage: e.target.value}); this.props.updateLead({monthlyRepayments:e.target.value}); }} />
                        </div>
                        
                        <div className='column2 justify-s'>
                            <NumberInput
                                id='monthlySavings'
                                key='monthlySavings'
                                label={<>Monthly savings</>}
                                value={this.props.monthlySavings}
                                classes={this.state.hasError && !this.state.monthlySavings ? "e" : ""}
                                onChange={(e) => { this.setState({monthlySavings: e.target.value}); this.props.updateLead({monthlySavings:e.target.value}); }} />
                        </div></>)}
                    {this.props.mortgageType==='switcher' && (<>
                        <div className='column2 justify-c'>
                            <NumberInput
                                id='monthlySavings'
                                key='monthlySavings'
                                label={<>Monthly savings</>}
                                value={this.props.monthlySavings}
                                classes={this.state.hasError && !this.state.monthlySavings ? "e" : ""}
                                onChange={(e) => { this.setState({monthlySavings: e.target.value}); this.props.updateLead({monthlySavings:e.target.value}); }} />
                        </div></>)}
                    </div></div>
                        {/* <div className='row'></div> */}
                        <div className='row'>
                        {/* {this.props.mortgageamount <180000 && (<>
                        <div className='column2 justify-s'>
                            <NumberInput
                                id='lvloanrepayment'
                                key='lvloanrepayment'
                                label={<>Loan Repayments per month (excluding mortgages)? </>}
                                value={this.props.lvloanrepayment}
                                classes={this.state.hasError && !this.state.lvloanrepayment ? "e" : ""}
                                onChange={(e) => { this.setState({lvloanrepayment: e.target.value}); this.props.updateLead({lvloanrepayment:e.target.value}); }} />
                        </div> </>)} */}

                    {this.state.hasError &&
                        <ErrorBox errors={this.state.errors!} />
                    }
                    <div className='row'>
                        <div className='button-group'>
                            <PreviousButton onClick={() => this.props.prevStep()} />
                            <NextButton onClick={() => this.nextStep()} />
                        </div>
                    </div>
                    <div className='row mt-2'>
                        <LenderRow />
                    </div>

                </div>
            </header>
        );
    }
}
